export enum ProductTransferStatus {
  Pending = 'pending',
  Completed = 'completed',
  Incidence = 'incidence',
  Resolved = 'resolved',
}
